import { Button } from "@design-system/Button/Button";
import { CollapseIcon, ExpandIcon } from "@icons";
import { ExpandedState } from "@tanstack/react-table";
import { ViewTableHandle } from "./ViewTable";
import { useToggleAllExpansion } from "./useToggleAllExpansion";

interface Props {
    expanded: ExpandedState;
    tableRef: React.RefObject<Pick<
        ViewTableHandle,
        "expandAll" | "collapseAll"
    > | null>;
}

export const CollapseAllButton = ({ expanded, tableRef }: Props) => {
    const { isAllCollapsed, toggleAll } = useToggleAllExpansion({
        expanded,
        tableRef,
    });

    return (
        <Button
            iconOnly
            variant="primary"
            size="md"
            onClick={toggleAll}
            aria-label={isAllCollapsed ? "Expand all" : "Collapse all"}
        >
            {isAllCollapsed ? <ExpandIcon /> : <CollapseIcon />}
        </Button>
    );
};
